import type * as ShowLoyaltyDialog from '@ori-events/show-loyalty-dialog';
import React, { useMemo } from 'react';
import type { FC } from 'react';

import type { Translations } from '../types';
import { appContext } from './appContext';
import { DEFAULT_TRANSLATIONS } from '~/constants';

export interface AppContextProviderProps {
  translations?: Partial<Translations>;
  data: ShowLoyaltyDialog.Data;
}

export const AppContextProvider: FC<AppContextProviderProps> = ({
  translations,
  data,
  children,
}) => {
  const value = useMemo(
    () => ({
      translations: {
        ...DEFAULT_TRANSLATIONS,
        ...translations,
      },
      data,
    }),
    [translations, data],
  );

  return <appContext.Provider value={value}>{children}</appContext.Provider>;
};
